import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import Texture from '../webgl/texture';
import { isWebGL2 } from '../webgl-utils';
var Texture2DArray = /*#__PURE__*/
function (_Texture) {
  _inherits(Texture2DArray, _Texture);
  _createClass(Texture2DArray, null, [{
    key: "isSupported",
    value: function isSupported(gl) {
      return isWebGL2(gl);
    }
  }]);
  function Texture2DArray(gl) {
    var _this;
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Texture2DArray);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Texture2DArray).call(this, gl, opts));
    throw new Error('Texture2DArray not yet implemented');
    return _this;
  }
  return Texture2DArray;
}(Texture);
export { Texture2DArray as default };